import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';

import reportWebVitals from './reportWebVitals.ts';
// Import the generated route tree
import { routeTree } from './routeTree.gen';
import './styles.css';
import { createRouter, RouterProvider } from '@tanstack/react-router';

import { AuthProvider } from '@frontend/features/auth/components/AuthProvider';
import { ensureMsalInitialized } from '@frontend/features/auth/config/msalInstance';
import { getAuthMode } from '@frontend/features/auth/util/util.auth.getAuthMode';

// Create a new router instance
const router = createRouter({
  routeTree,
  context: {},
  defaultPreload: 'intent',
  scrollRestoration: true,
  defaultStructuralSharing: true,
  defaultPreloadStaleTime: 0,
});

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

// Initialize and render the app
async function initializeApp() {
  const rootElement = document.getElementById('app');
  if (!rootElement || rootElement.innerHTML) {
    return;
  }

  try {
    const root = ReactDOM.createRoot(rootElement);

    // Ensure MSAL is initialized before rendering (only needed in MSAL mode)
    const authMode = getAuthMode();
    if (authMode === 'msal') {
      await ensureMsalInitialized();
    }

    root.render(
      <StrictMode>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </StrictMode>,
    );
  } catch (error) {
    console.error('Failed to initialize app:', error);

    // Render error state
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          flexDirection: 'column',
          gap: '1rem',
        }}
      >
        <h1
          style={{ color: '#dc2626', fontSize: '1.5rem', fontWeight: 'bold' }}
        >
          Authentication Error
        </h1>
        <p style={{ color: '#6b7280' }}>
          Failed to initialize authentication. Please refresh the page.
        </p>
        <button
          onClick={() => window.location.reload()}
          style={{
            padding: '0.5rem 1rem',
            backgroundColor: '#3b82f6',
            color: 'white',
            border: 'none',
            borderRadius: '0.375rem',
            cursor: 'pointer',
          }}
        >
          Refresh Page
        </button>
      </div>,
    );
  }
}

// Initialize the app
initializeApp();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
